import type { SVGProps } from 'react';

export function CowboyIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.833 5.254 4.905 13.93a3 3 0 0 0 2.295 1.07h9.6c.922 0 1.744-.417 2.295-1.07l-1.927-8.677a2.11 2.11 0 0 0-3.33-1.23l-.177.131a2.77 2.77 0 0 1-3.322 0l-.177-.131a2.11 2.11 0 0 0-3.33 1.23M2.4 12c0-.664-.536-1.2-1.2-1.2S0 11.336 0 12c0 3.975 3.225 7.2 7.2 7.2h9.6c3.975 0 7.2-3.225 7.2-7.2 0-.664-.536-1.2-1.2-1.2s-1.2.536-1.2 1.2a4.8 4.8 0 0 1-4.8 4.8H7.2A4.8 4.8 0 0 1 2.4 12" />
    </svg>
  );
}
